import App from '../App';

const AppLayout = ({ children }) => {
  return <App>{children}</App>;
};

export const getLayout = (page) => <AppLayout>{page}</AppLayout>;

export default AppLayout;
